import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import { IconButton } from 'ksnm-common-ui/lib/IconButton';

import { usePermission } from '@src/utils/hooks/usePermission';
import { objectFieldsToCamelCase } from '@src/utils/objectFieldsToCamelCase';
import { confirmDialogStore } from '@stores/confirmDialog';
import { counterpartiesStore } from '@stores/dictionaryStores/counterpartiesStore/counterpartiesStore';

import { RoutePath } from '../../../../AppRouter/constants';
import { NEW_ENTITY_ID } from '../../../../AppRouter/hooks/constants';

export const ActionButton = observer(({ update }: { update: () => void }) => {
  const { push } = useHistory();
  const { groupDelete, checked, setChecked } = counterpartiesStore;
  const { open: openConfirmDialog } = confirmDialogStore;

  const permission = usePermission('CmPartners');

  const onCreate = useCallback(() => {
    push(`${RoutePath.DICTIONARY_COUNTERPARTIES}/${NEW_ENTITY_ID}`);
  }, [push]);

  const onEdit = useCallback(() => {
    push(
      `${RoutePath.DICTIONARY_COUNTERPARTIES}/${checked[0]?.code}/${checked[0]?.counterparty_type_code}/${
        checked[0]?.org_local ?? ''
      }`,
    );
  }, [checked, push]);

  const onDelete = useCallback(() => {
    openConfirmDialog({
      text: `
      Из выбранного справочника будет удалено следующее число записей (${checked.length})
      После нажатия кнопки "Да" отмена изменений будет невозможна
      Подтвердить удаление записей?
      `,
      onOk: () => {
        const items = checked.map((item) => objectFieldsToCamelCase(item));

        groupDelete(items).then(() => {
          setChecked([]);
          update();
        });
      },
      iconType: 'warning',
      iconFill: 'red',
      width: 480,
    });
  }, [checked, groupDelete, openConfirmDialog, setChecked, update]);

  const onCopy = useCallback(() => {
    const isCopy = objectFieldsToCamelCase({ ...checked[0], counterparty: !checked[0]?.firstName });
    delete isCopy.openTarget;
    push(`${RoutePath.DICTIONARY_COUNTERPARTIES}/${NEW_ENTITY_ID}`, { isCopy });
  }, [checked, push]);

  return (
    <>
      {permission.CREATE && <IconButton onClick={onCreate} iconName="add" title="Добавить" />}
      {permission.UPDATE && (
        <IconButton onClick={onEdit} disabled={checked.length !== 1} iconName="edit" title="Редактировать" />
      )}
      {permission.DELETE && (
        <IconButton onClick={onDelete} disabled={checked.length === 0} iconName="delete" title="Удалить" />
      )}
      {permission.CREATE && (
        <IconButton onClick={onCopy} disabled={checked.length !== 1} iconName="copy" title="Копировать" />
      )}
    </>
  );
});
